// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__mECS_","errorLogs":"EditorFooter_errorLogs__14-G6"};